export type ObservablePropertyOptions = Record<string, never>;